import type { TOC } from '@ember/component/template-only';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type Patient from 'parog-web/models/patient';
import DiagnosticFields from '../hemato-cancer/diagnostic-fields';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient: Patient;
  };
}

export default <template>
  <DiagnosticFields @form={{@form}} @patient={{@patient}} />
</template> satisfies TOC<Signature>;
